import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledCollectionSourceProfileCard = styled(Box)`
  width: 100%;
  height: 100%;
  padding: 0;
  position: relative;

  transition: ${props => props.theme.transitions.create(['height'], {
    easing: props.theme.property('transitions.easing.easeOut'),
    duration: props.theme.property('transitions.duration.leavingScreen')
  })} !important;

  .ProfileCardContent {
    width: 100%;
    height: 100%;
    padding: 0;
  }
  
  .ProfileCard {
    &-header {
      position: absolute;
      width: 100%;
      z-index: 1;
      pointer-events: none;

      .MuiCardHeader-action {
        pointer-events: all;
      }
    }
  }


  &.CollectionSourceProfileCard-isDeleted {
    visibility: hidden;
  }
  
  ${ComponentStyles}
`;

StyledCollectionSourceProfileCard.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionSourceProfileCard;
